import { paths } from '../paths';
import { lazyLoadPage } from '../utils';

export const rootRoutes = [
  {
    path: paths.UNDER_MAINTENANCE,
    element: lazyLoadPage('under-maintenance', { path: '(root)/' }),
    state: {
      pageKey: 'underMaintenance',
      metadata: {
        title: 'Under maintenance'
      }
    }
  },
  {
    path: paths.NOT_FOUND,
    element: lazyLoadPage('not-found', { path: '(root)/' }),
    state: {
      pageKey: 'notFound',
      metadata: {
        title: '404 Not Found'
      }
    }
  },
  {
    path: paths.ERROR,
    element: lazyLoadPage('error', { path: '(root)/' }),
    state: {
      pageKey: 'error',
      metadata: {
        title: '503 Service Unavailable'
      }
    }
  },
  {
    path: '*',
    element: lazyLoadPage('not-found', { path: '(root)/' }),
    state: {
      pageKey: 'notFound',
      metadata: {
        title: '404 Not Found'
      }
    }
  }
];
